import type { Extension } from '@atlassian/forge-ui';

export const isBlockedByAppAccessRule = (extension?: Extension): boolean =>
	extension?.dataClassificationPolicyDecision?.status === 'BLOCKED';
